const i18n = {
  'datePicker': {
    'previousMonth': '前一個月份',
    'nextMonth': '下一個月份',
  }
};
export default i18n;
